import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDatePicker, Cell, Mode } from "../../Components/AxDatepicker/AxDatepicker";
import { AxDropdown } from "@axess/limestone";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import Swal from "sweetalert2";

@ModuleName("ComplexPackageDetails")
export class ComplexPackageDetails implements AxInit {

    protected axLoading: AxLoading;

    protected datePicker: AxDatePicker;
    protected datePickerMobile: AxDatePicker;

    protected dateDropdown: AxDropdown = new AxDropdown();
    protected dateMobileDropdown: AxDropdown = new AxDropdown();

    protected activateDate: moment.Moment = null;
    protected datePattern: string;
    protected projNr: number;
    protected packageId: number;
    protected tariffSheetId: number;
    protected selectedSoapDate: string;
    protected userLoggedIn: boolean;

    private selectedBookingDateKey: string = "selectedCompackBookingDate";

    constructor(private _I18nHelper = new I18nHelper()) { }

    AxInit(initData: ICompPackDetailsInitData): void {
        this.axLoading = new AxLoading();

        const that = this;

        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                that.axLoading.HideLoadingIndicator($('.compPack_details_body')[0]);
            }
        });

        this.dateDropdown.init('.prod_selection__date-selection .ax-dropdown');
        this.dateMobileDropdown.init('.compPack-searchbar__date-selection-mobile .ax-dropdown');

        this.datePattern = initData.datePatternYear;
        this.projNr = initData.projNr;
        this.packageId = initData.packageId;
        this.tariffSheetId = initData.tariffSheetId;
        this.userLoggedIn = JSON.parse(initData.userLoggedIn);

        let selectedCompackBookingDate = localStorage.getItem(this.selectedBookingDateKey);

        // check if this is a redirect after login
        // if yes -> use date from localstorage and proceed to booking options
        if (selectedCompackBookingDate) {

            let selectedDateMoment = moment(selectedCompackBookingDate);
            this.activateDate = selectedDateMoment;
            const formattedDate = selectedDateMoment.format(this.datePattern);
            this.dateDropdown.setValue(formattedDate);
            this.dateMobileDropdown.setValue(formattedDate);

            const selectedSoapDateTemp = this.activateDate.format('YYYY-MM-DD');
            this.selectedSoapDate = selectedSoapDateTemp;

            localStorage.removeItem(this.selectedBookingDateKey);

            this.bookingOptions();
        }

        $('[data-booking-btn]').prop("disabled", true);        

        // if no first valid date was found
        if (initData.startDate === '') {
            Swal.fire({
                title: 'Problem occurred',
                text: 'Product not availeable. Please contact the support.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok'
            }).then((result) => {

            });

            return;
        }

        this.addDatePickerListener(initData);

        $('[data-booking-btn]').on('click', () => this.bookingOptions());

        window.addEventListener('mouseup', event => {
            const target = event.target as HTMLInputElement;
            this.closeOpenSelectors(target);
        });
    }

    // addDatePickerListener
    addDatePickerListener(initData: ICompPackDetailsInitData) {
        const endDate = initData.endDate != null ? moment(initData.endDate, "YYYY-MM-DD") : null;
        const startDate = moment(initData.startDate, "YYYY-MM-DD");

        $('.prod_selection__date-selection').click(x => {

            this.initDatePicker(initData, endDate, startDate);
            $('.compPack_details_package_includes_datePickerWrapper').addClass('active');
            $('.prod_selection__date-wrapper').toggleClass('active');
        });

        $('.compPack-searchbar__date-selection-mobile').click(x => {
            this.initDatePickerMobile(initData, endDate, startDate);

            $('.compPack_searchBar-datePicker-wrapper-mobile').toggleClass('active');
            $('body').addClass('overflow-hidden');
        });

        $('.compPack-datePicker-close-btn').click(x => {
            $('.compPack_searchBar-datePicker-wrapper-mobile').removeClass('active');
        });
    }

    // initDatePicker
    initDatePicker(initData: ICompPackDetailsInitData, endDate: moment.Moment, startDate: moment.Moment) {
        if (this.datePicker != null) {
            return;
        }

        this.datePicker = new AxDatePicker();

        this.datePicker.Init({
            StartOfWeek: initData.startOfWeek,
            Lang: initData.lang,
            StartDate: startDate,
            Target: '#arrival_date',
            Mode: Mode.Inline,
            EndDate: endDate,
            OnChange: (x, y) => { return this.onChangeDate(x, y) },
            OnlySelectDates: true
        });

        this.datePicker.ActivationSubject.subscribe(x => this.checkDate(x));
    }


    // compPack_searchBar-datePicker-wrapper-mobile

    // initDatePickerMobile
    initDatePickerMobile(initData: ICompPackDetailsInitData, endDate: moment.Moment, startDate: moment.Moment) {
        if (this.datePickerMobile != null) {
            return;
        }

        this.datePickerMobile = new AxDatePicker();

        this.datePickerMobile.Init({
            StartOfWeek: initData.startOfWeek,
            Lang: initData.lang,
            StartDate: moment(initData.startDate, "YYYY-MM-DD"),
            DayRange: 2,
            Target: '#tariff_date_mobile',
            Mode: Mode.Endless,
            LegendTarget: '#tariff_date_mobile__legend',
            EndDate: endDate,
            OnChange: (x, y) => { return this.onChangeMobileDate(x, y) },
            OnlySelectDates: true
        });

        this.datePickerMobile.ActivationSubject.subscribe(x => this.checkDateMobile(x));
    }

    // closeOpenSelectors
    closeOpenSelectors(clickedElement: HTMLElement) {
        const locationSelect = $(".compPack_details_package_includes_datePickerWrapper");
        if (!locationSelect.is(clickedElement) && locationSelect.has(clickedElement).length === 0) {
            if ($('.compPack_details_package_includes_datePickerWrapper').hasClass('active')) {
                $('.compPack_details_package_includes_datePickerWrapper').removeClass('active');
            }

            $('body').removeClass('overflow-hidden');
        }
    }

    // onChangeDate
    onChangeDate(startDate: moment.Moment, endDate: moment.Moment): Promise<void> {
        return new Promise<void>((res, rej) => {
            const availableDates: moment.Moment[] = [];
            this.checkAvailability(startDate, endDate);
            this.datePicker.Options.AvailableDates = availableDates;
            res();
        });
    }

    // onChangeMobileDate
    onChangeMobileDate(startDate: moment.Moment, endDate: moment.Moment): Promise<void> {
        return new Promise<void>((res, rej) => {
            const availableDates: moment.Moment[] = [];
            this.checkAvailability(startDate, endDate);
            this.datePickerMobile.Options.AvailableDates = availableDates;
            res();
        });
    }

    // bookingOptions
    bookingOptions() {
        let body = $('.compPack_details_body')[0];
        this.axLoading.ShowLoadingIndicatorFixed(body);

        let url = $("#bookingOptionsLinkHidden").val().toString();
        url = url.replace('_soaPDate', this.selectedSoapDate);
        window.location.href = url;
    }

    // checkDate
    checkDate(x: Cell) {
        if (x != null) {
            this.activateDate = x.Date;
            const formattedDate = this.activateDate.format(this.datePattern);
            this.dateDropdown.setValue(formattedDate);

            $('.compPack_details_package_includes_datePickerWrapper').removeClass('active');

            const selectedSoapDateTemp = this.activateDate.format('YYYY-MM-DD');

            $('[data-booking-btn="desktop"]').html(`${this._I18nHelper.GetTranslation(Translations.BookNow)}`);
            $('[data-booking-btn="desktop"]').prop("disabled", false);            
            this.selectedSoapDate = selectedSoapDateTemp;

        } else {
            this.dateDropdown.resetSelection();
            this.activateDate = null;
        }
    }

    // checkDateMobile
    checkDateMobile(cell: Cell) {
        if (cell != null) {
            this.activateDate = cell.Date;
            const formattedDate = this.activateDate.format(this.datePattern);
            this.dateMobileDropdown.setValue(formattedDate);

            $('.compPack_searchBar-datePicker-wrapper-mobile').removeClass('active');

            const selectedSoapDateTemp = this.activateDate.format('YYYY-MM-DD');

            $('[data-booking-btn="mobile"]').html(`${this._I18nHelper.GetTranslation(Translations.BookNow)}`);
            $('[data-booking-btn="mobile"]').prop("disabled", false);
            this.selectedSoapDate = selectedSoapDateTemp;

            this.dateMobileDropdown.jumpToElement();
        } else {
            this.dateMobileDropdown.jumpToElement();
            this.activateDate = null;
        }
    }

    // checkAvailability
    checkAvailability(fromDate: moment.Moment, toDate: moment.Moment) {
        const data = {
            arcNr: null,
            soapFromDate: fromDate.format('YYYY-MM-DD'),
            soapToDate: toDate.format('YYYY-MM-DD'),
            projNr: this.projNr,
            tariffSheetId: this.tariffSheetId,
            packageId: this.packageId
        };

        this.axLoading.ShowLoadingIndicator($('.compPack_details_package_includes_datePickerWrapper')[0]);
        this.axLoading.ShowLoadingIndicator($('.prod_selection__scrollable')[0]);

        AxessViewer.ajaxRequest('/api/ComplexPackagesValidDaysApi/GetValidDaysCompPack', data, response => {
            for (let i = 0; i < response.Days.length; i++) {

                const dateTemp = response.Days[i];

                if (!dateTemp.IsValid || !dateTemp.IsStartDay || dateTemp.TicketsAvailable < 1) {

                    const momentDate = moment(dateTemp.Date);

                    if (this.datePicker != null) {
                        this.datePicker.BlockDate(momentDate);
                    }

                    if (this.datePickerMobile != null) {
                        this.datePickerMobile.BlockDate(momentDate);
                    }
                }
            }

            this.axLoading.HideLoadingIndicator($('.compPack_details_package_includes_datePickerWrapper')[0]);
            this.axLoading.HideLoadingIndicator($('.prod_selection__scrollable')[0]);

        }, null);
    }
}

export interface ICompPackDetailsInitData {
    startOfWeek: number;
    lang: string;
    startDate: string;
    endDate?: string;
    postUrl: string;
    datePattern: string;
    datePatternYear: string;
    checkDateLink: string;
    projNr: number;
    packageId: number;
    tariffSheetId: number;
    userLoggedIn: string;
}